import type { RouteLocationNormalized } from '#vue-router'

export const useLoadRecordContest = () => {
  const wapersStore = useWapersStore()
  const recordContestsStore = useRecordContestsStore()
  const slidersStore = useDoNotMissStore()

  return async (route: RouteLocationNormalized) => {
    try {
      await Promise.all([
        wapersStore.fetchUserWapers(),
        recordContestsStore.fetchRecordContest({
          slug: route.params.contestName as string,
        }),
        // Fetch data for slider `Do Not Miss`
        slidersStore.fetchDoNotMiss(),
      ])
    } catch (error) {
      console.error('from page', error)
    }

    throwIfNotFound(recordContestsStore.recordContest)
  }
}
